import ISO6391 from "iso-639-1";

// The catalogue the Add Language modal picks from, one option per ISO 639-1
// language. Values are names because tenant options are addressed by name on
// the wire (LanguageRequirement.language holds "English", not "en").
export const languageOptions = ISO6391.getAllCodes()
  .map((code) => ({ code, name: ISO6391.getName(code) }))
  .sort((a, b) => a.name.localeCompare(b.name))
  .reduce((options, { name }) => {
    if (!options.some((option) => option.value.toLowerCase() === name.toLowerCase())) {
      options.push({ value: name, label: name });
    }
    return options;
  }, []);
